<script setup lang="ts">
import { cardKey } from "@/components/StickyNote/injectKeys";
import ActionSource from "@/components/action/ActionSource.vue";
import MoreMenu from "@/components/menu/ActionMenu/MoreMenu.vue";
import DeleteMenuItem from "@/components/menu/DeleteMenuItem/DeleteMenuItem.vue";
import DevLinksMenuItem from "@/components/menu/DevLinksMenuItem/DevLinksMenuItem.vue";
import StoryPointsMenuItem from "@/components/menu/SetStoryPoints/StoryPointsMenuItem.vue";
import StickyStatusMenuItem from "@/components/menu/StickyStatus/StickyStatusMenuItem.vue";
import type { BoardCard } from "@/model/card";
import { injectStrict } from "@/utils/vue";

import EnablingTeamMenuItem from "../EnablingTeamMenuItem/EnablingTeamMenuItem.vue";
import ActivityMenuItem from "./internal/ActivityMenuItem.vue";
import AlmMenuItem from "./internal/AlmMenuItem.vue";
import BreakdownMenuItem from "./internal/BreakdownMenuItem.vue";
import ChangeArtMenuItem from "./internal/ChangeArtMenuItem/ChangeArtMenuItem.vue";
import ChangeProjectMenuItem from "./internal/ChangeProjectMenuItem/ChangeProjectMenuItem.vue";
import DuplicateMenuItem from "./internal/DuplicateMenuItem.vue";
import LinkMenuItem from "./internal/LinkMenuItem.vue";
import MapMenuItem from "./internal/MapMenuItem.vue";
import MirrorMenuItem from "./internal/MirrorMenuItem.vue";
import MirrorToArtBoardMenuItem from "./internal/MirrorToArtBoardMenuItem.vue";
import MoveMenuItem from "./internal/MoveMenuItem/MoveMenuItem.vue";
import PinMenuItem from "./internal/PinMenuItem.vue";
import ShareMenuItem from "./internal/ShareMenuItem/ShareMenuItem.vue";
import StickyTypeMenuItem from "./internal/StickyTypeMenuItem/StickyTypeMenuItem.vue";
import TeamMenuItem from "./internal/TeamMenuItem.vue";
import WsjfMenuItem from "./internal/WsjfMenuItem.vue";

const card = injectStrict(cardKey);

const trapOptions = {
  returnFocusOnDeactivate: false,
  // Focus trap should contain the card as well as the action menu
  extraElements: [card.id],
  // Fixes bug when card+dialog close at the same time (eg. when deleting a card)
  fallbackFocus: `[id='${card.id}']`,
};
</script>

<template>
  <ActionSource
    :id="'action-menu-' + card.id"
    v-focus-trap="trapOptions"
    value="action-menu"
    style="display: contents"
  >
    <StickyTypeMenuItem />
    <TeamMenuItem />
    <MirrorToArtBoardMenuItem />
    <MirrorMenuItem />
    <LinkMenuItem />
    <DuplicateMenuItem />
    <PinMenuItem />
    <MapMenuItem />
    <DeleteMenuItem :cards="[{ data: card } as BoardCard]" />
    <MoreMenu>
      <StickyStatusMenuItem />
      <StoryPointsMenuItem />
      <WsjfMenuItem />
      <EnablingTeamMenuItem />
      <ChangeArtMenuItem />
      <ChangeProjectMenuItem />
      <MoveMenuItem />
      <DevLinksMenuItem />
      <BreakdownMenuItem />
      <AlmMenuItem />
      <ShareMenuItem />
      <ActivityMenuItem />
    </MoreMenu>
  </ActionSource>
</template>
